import { useEffect, useState } from 'react';
import { Row, Col, Tabs, Breadcrumb, Spin } from 'antd';
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import Box from '../../../components/utility/box';
import { DvIntlMessages } from '../../../components/utility/dvGeneralUtilities';
import IntlMessages from "../../../components/utility/intlMessages";
import systemActions from '../../../redux/systemInfos/actions';
import userStyles from '../../Clinics/clinics.module.scss'
import HealthRecords from '../../Clinics/ClinicDetails/clinicDetails.hr';
import UserDetailsGeneral from './userDetails.general';
import UserBackgroundJobs from './userDetails.backgroundJobs'
import AuditLogs from '../../AuditLogs/auditLogs';

const TABS_KEYS = ['general', 'auditLogs', 'healthRecords', 'backgroundJobs']

const { TabPane } = Tabs;

const { getUserDetails } = systemActions;

function UserDetails(props) {
  const [activeTab, setActiveTab] = useState('general');

  useEffect(() => {
    props.getUserDetails(props.match.params.userId)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.match.params?.userId])

  useEffect(() => {
    const { selectedTab } = props.match.params;
    if (TABS_KEYS.includes(selectedTab)) setActiveTab(selectedTab);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.match.params?.selectedTab])

  function handleOnChangeTab(key) {
    setActiveTab(key);
  }

  function breadcrumbRenderFactory(selectedTab) {
    return (
      <Breadcrumb>
        <Breadcrumb.Item
          className={userStyles.breadcrumbItem}
          onClick={() => props.history.push('/Dashboard/clinics')}
        >
          <IntlMessages id="general.clinics" />
        </Breadcrumb.Item>

        <Breadcrumb.Item className={userStyles.breadcrumbItem}
        onClick={() => props.history.push(`/Dashboard/clinicDetails/${props.userDetails.clinicId}/general`)}
        >
          {props.userDetails.clinicTitle}
        </Breadcrumb.Item>

        <Breadcrumb.Item
          className={userStyles.breadcrumbItem}
          onClick={() => props.history.push(`/Dashboard/clinicDetails/${props.userDetails.clinicId}/users`)}
        >
          <IntlMessages id="general.users" />
        </Breadcrumb.Item>

        <Breadcrumb.Item onClick={() => setActiveTab('general')} className={userStyles.breadcrumbItem}>
          {`${props.userDetails.lastName} ${props.userDetails.firstName}`}
        </Breadcrumb.Item>

        <Breadcrumb.Item>
          <IntlMessages id={`general.${selectedTab}`} />
        </Breadcrumb.Item>
      </Breadcrumb>
    )
  }

  return (
    <Spin spinning={props.loading > 0}>
      <Box>
        <Row gutter={[16, 16]} style={{overflowX: 'auto'}}>
          <Col span={24}>
            <Tabs defaultActiveKey="general" onChange={handleOnChangeTab} activeKey={activeTab}>
              <TabPane tab={DvIntlMessages('general.general').toUpperCase()} key="general">
                {breadcrumbRenderFactory('general')}
                {props.userDetails &&
                  <UserDetailsGeneral data={props.userDetails} />}
              </TabPane>
              <TabPane tab={DvIntlMessages('general.healthRecords').toUpperCase()} key="healthRecords">
                {breadcrumbRenderFactory('healthRecords')}
                <HealthRecords data={props.userDetails?.healthRecords} />
              </TabPane>
              <TabPane tab={DvIntlMessages('general.backgroundJob').toUpperCase()} key="backgroundJobs">
                {breadcrumbRenderFactory('backgroundJob')}
                <UserBackgroundJobs />
              </TabPane>
              <TabPane tab={DvIntlMessages('general.auditLogs').toUpperCase()} key="auditLogs">
                {breadcrumbRenderFactory('auditLogs')}
                <AuditLogs />
              </TabPane>
            </Tabs>
          </Col>
        </Row>
      </Box>
    </Spin>
  )
}

UserDetails.propTypes = {
  userDetails: PropTypes.object.isRequired,
  loading: PropTypes.number.isRequired,

  getUserDetails: PropTypes.func.isRequired
};

UserDetails.defaultProps = {
  userDetails: {}
}

const mapActionsToProps = {
  getUserDetails
};

function mapStateToProps(state) {
  return {
    userDetails: state.SystemInfos.get('userDetails'),
    loading: state.SystemInfos.get('loading')
  };
}

const wrappedUserDetails = withRouter(UserDetails);
const connectedUserDetails = connect(mapStateToProps, mapActionsToProps)(wrappedUserDetails);
export default connectedUserDetails;